<template>
	<div class="box">
		<div class="main">
			<van-steps :active="active">
				<van-step>输入信息</van-step>
				<van-step>操作完成</van-step>
			</van-steps>
			<div class="form">
				<van-form validate-first @failed="onFailed">
					<van-field v-model="commitData.phoneNumber" label="手机号码" placeholder="请输入手机号码" />
				</van-form>
			</div>
		</div>
		<div class="footer">
			<van-button round block type="info" size="mini" native-type="submit" @click="submitdata">提交</van-button>
		</div>
	</div>
</template>

<script>
import { changePatientPhone } from '@/api/api'
import { Toast } from 'vant'
export default {
	props: {},
	data () {
		return {
			commitData: {
				phoneNumber: '',
			},
			active: 0,
		};
	},
	computed: {
	},
	created () { },
	mounted () { },
	watch: {},
	methods: {
		submitdata () {
			let commit = this.commitData
			if (
				!(this.formV('empty', commit.phoneNumber, '请输入手机号码') &&
					this.formV('tel', commit.phoneNumber, '请输入正确手机号码'))
			) return
			let data = {
				patientId: this.$route.query.id,
				phoneNum: commit.phoneNumber
			}
			changePatientPhone(data).then((res) => {
				if (res.msg !== null) {
					Toast.success(res.msg)
					this.$loading.hide()
					this.$router.push({
						path: 'index'
					})
				} else {
					Toast.fail('修改失败')
				}
			})
		},
		formV (type, str, label) {
			label = label || ''
			let regular = ''
			switch (type) {
				// 空
				case 'empty':
					regular = /\S+/
					break
				// 数字验证
				case 'price':
					regular = /[0-9]*[1-9][0-9]*/
					break
				// 手机号
				case 'tel':
					regular = /^1\d{10}$/
					break
				// 身份证
				case 'IDCard':
					regular = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
					break
				// 邮箱
				case 'email':
					regular = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
					break
				default:
					return true
			}
			if (!regular.test(str) || str == null) {
				Toast.fail(label)
				return false
			} else {
				return true
			}
		},
	},
	components: {},
};
</script>

<style scoped>
.form {
	border-bottom: 1px solid rgb(240, 240, 240);
}

.footer {
	width: 100vw;
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
	display: flex;
	background-color: #ffffff;
}

.footer button {
	width: calc(100% - 40px);
	margin: 10px 20px 10px 20px;
	height: 32px;
}
</style>
